import { useSetAtom } from "jotai";

import { useEffect, useState } from "react";

import {
  ConfigurationItemData,
  ConfigurationItemKind,
  useConfigurationApi,
  useConfigurationNavigationApi,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";
import { useSearch } from "@tanstack/react-router";

import { loadNavigationAtom } from "./loadNavigation";

export function JumpToTab(): null {
  const { setItems } = useConfigurationNavigationApi();
  const api = useConfigurationApi();
  const sessionId = useSessionId();

  const { cfgObjectId } = useSearch({
    strict: false,
  });

  const [typeCode, setTypeCode] = useState<string>("");
  const setLoadNavigation = useSetAtom(loadNavigationAtom);

  useEffect(() => {
    async function getProjectListInfo(): Promise<string> {
      const res = await api.invokeUserDefinedGetter({
        id: sessionId,
        name: "getProjectListInfo",
        invokeUserDefinedGetterParams: {
          path: "/XAS_PRODUCT_VIEW/0/",
          input: JSON.stringify({}),
        },
      });
      if (res?.output) {
        const data = JSON.parse(res?.output);
        setTypeCode(data.typeCode);
        setLoadNavigation({ sessionId, jumpsToProductView: !!data.typeCode });
        return res?.output;
      }
      setLoadNavigation({ sessionId, jumpsToProductView: false });
      return "";
    }

    getProjectListInfo().catch((error) => {
      console.error("getProjectListInfo failed", error);
      setLoadNavigation({ sessionId, jumpsToProductView: false });
    });
  }, [api, sessionId, setLoadNavigation]);

  useEffect(() => {
    let id = "";
    let path = "";

    if (typeCode) {
      switch (cfgObjectId) {
        case "CFG_PROFESSIONAL": {
          id = `/XAS_PRODUCT_VIEW`;
          path = `/XAS_PRODUCT_VIEW/0`;
          break;
        }
        default: {
          id = `/XAS_PRODUCT_VIEW`;
          path = `/XAS_PRODUCT_VIEW/0`;
        }
      }

      const target: ConfigurationItemData = {
        id: id,
        kind: ConfigurationItemKind.ConfigurationObject,
        path: path,
      };
      setItems([target]);
    }
  }, [setItems, cfgObjectId, typeCode, api, sessionId]);

  return null;
}
